import React from 'react';
import { Badge } from 'reactstrap';

const CONTRACT_TYPE_DISPLAY = {
  GETTONE: { label: 'Gettone', className: 'contract-type-gettone' },
  STORNO_GETTONE: {
    label: 'Storno Gettone',
    className: 'contract-type-storno-gettone',
  },
};

function ContractTypeBadgeField({ value }) {
  const contractType = CONTRACT_TYPE_DISPLAY[value];

  if (!contractType) return <>-</>;

  return (
    <Badge className={`px-2 py-1 ${contractType.className}`}>
      {contractType.label}
    </Badge>
  );
}

export default ContractTypeBadgeField;
